import React from 'react';
import FileViewer from 'react-file-viewer';

const DocumentViewer = ({ documents }) => {
  const handleFileLoadError = (error) => {
    console.error("Error loading file:", error);
  };

  if (!documents || !Array.isArray(documents) || documents.length === 0) {
    return <div>No documents to display.</div>;
  }

  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
      {documents.map((doc, index) => {

        const normalizedDoc = {
          ...doc,
          type: doc.type || doc.file_extension || "pdf",
          url: doc.url || doc.file_path || "",
          title: doc.title || doc.document_type || "Document"
        };

        return (
          <div key={index} style={{ marginBottom: '20px' }}>
            <h3>{normalizedDoc.title}</h3>

            <FileViewer
              fileType={normalizedDoc.type.toLowerCase()}   
              filePath={normalizedDoc.url}               
              onError={handleFileLoadError}
              style={{ width: '100%', height: '500px' }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default DocumentViewer;
